import TagManager from 'react-gtm-module'

export function InitializeTagManager(gtmContainerId: string) {
  TagManager.initialize({
    gtmId: gtmContainerId,
  })
}
